import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { Utils } from "../../helper/utils.helper";

let ExportDisabledDialogComponent = {
    selector: "vcExportDisabledDialog",
    templateUrl:
        "/angular/components/export/export-disabled-dialog.component.html",
    bindings: {},
    controller: class ExportDisabledDialogController {
        private dialog: DialogUtils;
        public utils: Utils;

        constructor(DialogUtils: DialogUtils, Utils: Utils) {
            this.dialog = DialogUtils;
            this.utils = Utils;
        }

        dismiss(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("export")
    .component(
        ExportDisabledDialogComponent.selector,
        ExportDisabledDialogComponent
    );
